module.exports = __webpack_public_path__ + "img/circle_ijo.52ae9ba1.png";